import React, { Component } from "react";
import { Button, Col, Form, Input, Row, Spin, Typography } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { formRules } from "../../utilities";
import { inject, observer } from "mobx-react";
import { Redirect, withRouter } from "react-router-dom";

@inject("context")
@withRouter
@observer
class Login extends Component {
	onFinish = (values) => {
		const service = this.props.context.applicationService;
		service.attemptUserLogin(values.email, values.password);
	};

	render() {
		const service = this.props.context.applicationService;

		if (service.isAuthenticated) {
			if (
				this.props.location &&
				this.props.location.state &&
				this.props.location.state.from
			) {
				return <Redirect to={this.props.location.state.from} />;
			}
			return <Redirect to="/policies" />;
		}

		if (service.isLocalStorageLoading()) {
			return (
				<div className="v-h-centered-container">
					<Spin size="large" tip="Loading..." />
				</div>
			);
		}

		return (
			<div className="v-h-centered-container">
				<Form
					onFinish={this.onFinish}
					style={{
						maxWidth: "450px",
					}}
				>
					<Row>
						<Col span={24}>
							<Typography.Title level={4}>Login</Typography.Title>
						</Col>
					</Row>
					<Row>
						<Col span={24}>
							<Form.Item
								name="email"
								htmlFor="email"
								rules={[formRules.required, formRules.email]}
							>
								<Input
									id="email"
									size="large"
									prefix={<UserOutlined />}
									placeholder="Enter your email..."
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row>
						<Col span={24}>
							<Form.Item
								name="password"
								htmlFor="password"
								rules={[formRules.required]}
							>
								<Input
									id="password"
									size="large"
									type="password"
									prefix={<LockOutlined />}
									placeholder="Enter your password..."
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row>
						<Col span={24}>
							<Form.Item>
								<Button size="large" block type="primary" htmlType="submit">
									Login
								</Button>
							</Form.Item>
						</Col>
					</Row>
				</Form>
			</div>
		);
	}
}

export default Login;
